export const measuringToolOptions = {
    shapeOptions: {
        guidelineDistance: 10,
        weight: 3,
        color: 'red',
    },
};
